(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/video-player-loader.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/video-player-loader.js'); 'use strict';

var _svs$components$emp_v = svs.components.emp_video_player.helpers.client,
    loadVideoComponent = _svs$components$emp_v.loadVideoComponent,
    startVideoPlayer = _svs$components$emp_v.startVideoPlayer,
    setupVideo = _svs$components$emp_v.setupVideo,
    setupVideoFromAttributes = _svs$components$emp_v.setupVideoFromAttributes;
var videoOptionsArray = [];

var checkParams = function checkParams(videos) {
  var errorNotArray = 'Param should be an array of video objects';
  var missingElementNode = 'Missing node property for video';
  var missingOptionsObject = 'Missing options object for video';

  if (!Array.isArray(videos)) {
    return errorNotArray;
  }

  for (var index = 0; index < videos.length; index++) {
    var video = videos[index];

    if (!video.node) {
      return missingElementNode;
    }

    if (!video.options) {
      return missingOptionsObject;
    }
  }
};


var prepareVideo = function prepareVideo(videos) {
  var jPromise = $.Deferred();
  var runParallell = [];
  var notValidParams = checkParams(videos);

  if (notValidParams) {
    return jPromise.reject(notValidParams);
  }

  videoOptionsArray = [];

  for (var index = 0; index < videos.length; index++) {
    var video = videos[index];

    if (video.options.noThumbnail) {
      videoOptionsArray.push(video);
    }

    runParallell.push(setupVideo(video.node, video.options));
  }

  return $.when.apply(null, runParallell);
};


var loadVideoPlayer = function loadVideoPlayer() {
  var responsePromise = $.Deferred();

  if (videoOptionsArray.length > 0) {
    try {
      loadVideoComponent(function () {
        var parallellJobs = [];

        var _loop = function _loop(index) {
          var video = videoOptionsArray[index]; 

          var parallellJob = $.Deferred();
          startVideoPlayer(video.node, video.options, function (error, response) {
            if (error) {
              parallellJob.reject(response);
            }

            parallellJob.resolve(response);
          });
          parallellJobs.push(parallellJob);
        };

        for (var index = 0; index < videoOptionsArray.length; index++) {
          _loop(index);
        } 


        $.when.apply(null, parallellJobs).then(function () {
          responsePromise.resolve();
        }).catch(function () {
          responsePromise.reject();
        });
      });
    } catch (error) {
      responsePromise.reject(error);
    }

    return responsePromise;
  }

  return responsePromise.resolve('Nothing to load');
};


var preRenderSetup = function preRenderSetup(videoElement) {
  if (videoElement) {
    var singleVideoElement = videoElement.querySelector('.js-emp-placeholder');
    setupVideoFromAttributes(singleVideoElement);
  } else {
    var videoElements = document.getElementsByClassName('js-emp-placeholder');

    for (var i = 0; i < videoElements.length; i++) {
      var element = videoElements[i];
      setupVideoFromAttributes(element);
    }
  }
};

svs.components.emp_video_player.contentLoader = {
  loadVideoPlayer: loadVideoPlayer,
  preRenderSetup: preRenderSetup,
  prepareVideo: prepareVideo
};
 })(window);